import CalistaUiComponentTranslationText from 'src/views/common/CalistaUiComponentTranslationText'
import EditIcon from '@material-ui/icons/Edit'
import React from 'react'
import { components } from 'cng-web-lib'

const {
  button: { CngPrimaryButton, CngSecondaryButton },
} = components

function UpdateButton(buttonProps) {

  const translatedTextsObject = CalistaUiComponentTranslationText()
  return (
    <div>
      <CngSecondaryButton {...buttonProps}><EditIcon />{translatedTextsObject.update}</CngSecondaryButton>
    </div>
  )

}

export default UpdateButton
